import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { Container } from 'reactstrap'

const AbsenceSkeleton: React.FC = () => {
  return (
    <Container>
      <Skeleton height={160} />
    </Container>
  )
}

export default AbsenceSkeleton
